import { render, staticRenderFns } from "./platformView.vue?vue&type=template&id=09c91f90&"
import script from "./platformView.vue?vue&type=script&lang=js&"
export * from "./platformView.vue?vue&type=script&lang=js&"
import style0 from "./platformView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports